/**
 * Effective merchant/payee for display and matching.
 * Order: merchant_data.name / merchant_data.merchant_name → merchant_name → counterparty_name → "".
 */

export type MerchantSource = {
  merchant_name?: string | null;
  counterparty_name?: string | null;
  merchant_data?: string | Record<string, unknown> | null;
};

function merchantFromData(merchantData: MerchantSource['merchant_data']): string {
  if (!merchantData) return '';
  try {
    const d =
      typeof merchantData === 'string' ? JSON.parse(merchantData) : merchantData;
    if (!d || typeof d !== 'object') return '';
    for (const key of ['name', 'merchant_name'] as const) {
      const v = (d as Record<string, unknown>)[key];
      if (typeof v === 'string' && v.trim()) return v.trim();
    }
  } catch {
    return '';
  }
  return '';
}

export function effectiveMerchantName(tx: MerchantSource | null | undefined): string {
  if (!tx) return '';
  const fromData = merchantFromData(tx.merchant_data);
  if (fromData) return fromData;
  const mer = String(tx.merchant_name || '').trim();
  if (mer) return mer;
  return String(tx.counterparty_name || '').trim();
}
